import getMappedProduct from './getMappedProduct';

export default (products = null, appProductConfig, pageType, messages, useIdentifier, config, userState = { user: {} }) => {
    if (!products) return null;

    const {
        availableImageSizes = [],
        badgeBlocklist = [],
        imageQuality,
        imagesphereAspectRatio,
        locale,
        pdpUrlTemplate,
        plpImageSrcSet,
        saleBadges,
    } = appProductConfig;
    const { user } = userState;

    return products.map((product) => {
        const consideredBadge = product?.attributes?.find(
            (attribute) => config?.head?.sustainabilityAttributes.includes(attribute.identifier) || attribute.identifier === 'CONSIDERED',
        );
        return product
            ? getMappedProduct({
                  id: product.productId,
                  product,
                  badgeBlocklist,
                  locale,
                  availableImageSizes,
                  pdpUrlTemplate,
                  imageQuality,
                  pageType,
                  messages,
                  saleBadges,
                  useIdentifier,
                  imagesphereAspectRatio,
                  consideredBadge: consideredBadge?.label ? consideredBadge?.label : null,
                  plpImageSrcSet,
                  user,
              })
            : null;
    });
};
